<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

      <div class="container ibcgp-publications-page" style="margin-top: 80px; margin-bottom: 80px;">
        <instagram-embed/>

        <div class="mt-5 pt-4 border-top">
          <publications-list/>
        </div>
      </div>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import PublicationsList from './List.vue';
  import InstagramEmbed from './InstagramEmbed.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Publicações e Instagram";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'instagram-embed'         : InstagramEmbed,
      'publications-list'       : PublicationsList,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
  }
</script>

